import { getTranslations } from "../../translations";
import { Popup, PopupButton, PopupPosition } from "../../utilities/popup";
import { sendDataLayer } from "../ecommerce/ecommerce";
import { numberSelect } from "../numberSelect";
import { Tooltip } from "../tooltip/tooltip";
import { modifyCartQuantity, removeUnnecessaryProperty } from "./shoppingcart";

(window as any).cartpopup = null;

export const openCartPopup = () =>
{
    const inCartPage = document.getElementsByClassName("shoppingcart");

    if (inCartPage.length > 0) return;

    if ((window as any).cartpopup === null) loadCart();

    if ((window as any).cartpopup !== null)
    {
        (window as any).cartpopup.show();
        document.getElementById("modal-cart-popup").classList.add("g-popup--visible");
    }
};

export const loadCart = (open: boolean = false) =>
{
    const inCartPage = document.getElementsByClassName("shoppingcart");
    const orderProcessPage = document.getElementsByClassName("js-header-orderprocess");

    if (inCartPage.length > 0 ||
        orderProcessPage.length > 0
    )
        return;

    // load cart dropdown
    $.ajax({
        url: "/Services/Modules/Webshop.asmx/GetShoppingCartDropdown",
        type: "GET",
        dataType: "html",
        complete: function (data)
        {
            let content: HTMLDivElement;
            let footer: HTMLDivElement;
            let buttons: Array<PopupButton> = [];

            if (data != null && data.responseText != null && data.responseText.length > 0)
            {
                initCartPopup(data);
            }

            if (data.responseText == null || data.responseText.length === 0)
            {
                initEmptyCartPopup(data);
            }

            new Tooltip(".tooltip");
        }
    });
}

const initCartPopup = (data: JQuery.jqXHR<any>) =>
{
    let content: HTMLDivElement;
    let footer: HTMLDivElement;
    let buttons: Array<PopupButton> = [];

    const element = document.createElement("div");
    element.innerHTML = data.responseText;

    footer = element.querySelector(".c-pricedetails") as HTMLDivElement;
    content = element.querySelector(".w-productlist") as HTMLDivElement;

    const cartButton: PopupButton = new PopupButton();
    cartButton.isAnchor = true;
    cartButton.url = getTranslations().shoppingCartUrlLowerCaseTxt;
    cartButton.className = "btn";
    cartButton.label = getTranslations().txtToShoppingCart;
    cartButton.closeOnCLick = true;
    cartButton.onClick = () =>
    {
        sendDataLayer({
            'event': 'Cartpopup',
            'action': 'ProceedToStep1'
        });
    }
    buttons.push(cartButton);

    const orderButton: PopupButton = new PopupButton();
    orderButton.isAnchor = true;
    if (shopConfig().userLoggedIn)
        orderButton.url = getTranslations().txtUtilStep2;
    else
        orderButton.url = getTranslations().loginUrl;
    orderButton.className = "btn btn-green btn-arrow-right";
    orderButton.label = getTranslations().txtToOrderfunnel;
    orderButton.closeOnCLick = true;
    orderButton.onClick = () =>
    {
        sendDataLayer({
            'event': 'Cartpopup',
            'action': 'ProceedToStep2'
        });
    }
    buttons.push(orderButton);

    content.querySelectorAll(".js-input-select").forEach((input: HTMLInputElement) =>
    {
        const select = new numberSelect(input, modifyCartQuantity);
    });

    removeUnnecessaryProperty(content);

    (window as any).cartpopup = new Popup({
        id: "cart-popup",
        popupClass: "g-popup__buttons--evenly, g-popup__container--w-480, g-popup__content--shadow",
        title: getTranslations().txtUtilShoppingCart,
        closeButton: true,
        content: content,
        footerContent: footer,
        buttons: buttons,
        mobilePosition: PopupPosition.Drawer,
        desktopPosition: PopupPosition.Right,
    });
}

const initEmptyCartPopup = (data: JQuery.jqXHR<any>) =>
{
    let content: HTMLDivElement;
    let footer: HTMLDivElement;
    let buttons: Array<PopupButton> = [];

    content = document.createElement("div");
    content.classList.add("w-productlist__empty")

    const contentText = document.createElement("p");
    contentText.classList.add("w-productlist__empty-title");
    const text = document.createTextNode(getTranslations().txtShoppingCartEmpty);

    contentText.appendChild(text);
    content.appendChild(contentText);

    const continueButton: PopupButton = new PopupButton();
    continueButton.className = "btn btn-arrow-left";
    continueButton.label = getTranslations().txtContinueShopping;
    continueButton.closeOnCLick = true;

    buttons.push(continueButton);

    (window as any).cartpopup = new Popup({
        id: "cart-popup",
        popupClass: "g-popup__buttons--evenly, g-popup__container--w-480, g-popup__content--shadow",
        title: getTranslations().txtUtilShoppingCart,
        closeButton: true,
        content: content,
        footerContent: footer,
        buttons: buttons,
        mobilePosition: PopupPosition.Drawer,
        desktopPosition: PopupPosition.Right,
    });
}

export const emptyCart = () =>
{
    let buttons: Array<PopupButton> = [];

    const content = document.createElement("div");
    content.classList.add("w-productlist__empty")

    const contentText = document.createElement("p");
    contentText.classList.add("w-productlist__empty-title");
    const text = document.createTextNode(getTranslations().txtShoppingCartEmpty);

    contentText.appendChild(text);
    content.appendChild(contentText);

    const continueButton: PopupButton = new PopupButton();
    continueButton.className = "btn btn-arrow-left";
    continueButton.label = getTranslations().txtContinueShopping;
    continueButton.closeOnCLick = true;
    buttons.push(continueButton);

    const popupEl = document.getElementById("modal-cart-popup");

    popupEl.querySelector(".g-popup__footer-content").remove();
    (window as any).cartpopup.updateFooter("", buttons);
    (window as any).cartpopup.updateContent(content.outerHTML);
}

if (!(window as any).cartLoaded)
{
    (window as any).cartLoaded = true;
    document.addEventListener("DOMContentLoaded", () =>
    {
        loadCart();
    });
}

(window as any).emptyCart = emptyCart;
(window as any).openCartPopup = openCartPopup;
